import React,{useState} from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../atoms/checkBox/Checkbox';
import { AccessoriesStyle } from './AccessoriesStyle';

const AccessoriesItem = (props) => {
  let [check, setCheck] = useState(false);
  const handleAccessoriesCheck = (event) => {
    let flag=event.target.checked;
    setCheck(flag)
    props.accessoriesClickHandler(flag)
  }

  const checkFilteredAccessories = () => {
    return props.filteredAccessories.filter(brand => brand.label === props.accessories.label).length > 0 ? true : false
  }

  return (
    <ul className='list'>
      <li>
        <Checkbox
          isChecked={
            props?.filteredAccessories?.length > 0 ? checkFilteredAccessories() :
              props?.filteredAccessories?.length === 0 ? false : check
          }
          id={`${props.accessories.label}`}
          check={`${props.accessories.label} `}
          click={handleAccessoriesCheck}
        />
      </li>
      <style jsx>{AccessoriesStyle}</style>
    </ul>
  );
};

AccessoriesItem.propTypes = {
  promoClickHandler: PropTypes.func,
  accessoriesClickHandler: PropTypes.func,
  filteredAccessories: PropTypes.array,
  accessories: PropTypes.object
};

export default AccessoriesItem;
